export default function App() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-6 md:p-10 lg:p-12 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                移动阅读
              </h2>
              <p className="text-sm md:text-base text-background-200/80 leading-relaxed mb-4 md:mb-6">
                星球漫画移动端完美适配手机与平板，提供专为触屏优化的下拉式阅读体验。
                无论在地铁、咖啡厅还是睡前床上，随时随地打开即读，离线缓存功能让你即使在无网络环境下也能畅享科幻漫画的宇宙世界。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-colors no-underline text-sm cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-smartphone-line"></i>
                  </span>
                  iOS 版下载
                </a>
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 border border-background-300/30 hover:border-background-200/50 text-background-100 font-medium rounded-full transition-colors no-underline text-sm cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-android-line"></i>
                  </span>
                  Android 版下载
                </a>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-4 md:p-6">
              <div className="relative w-48 h-80 md:w-56 md:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20sci-fi%20comic%20reading%20app%20interface%20displaying%20a%20colorful%20space%20comic%20page%20clean%20UI%20design%20warm%20orange%20accent%20colors%20modern%20minimal%20app%20layout%20dark%20mode%20reading%20experience%20on%20a%20phone%20screen&width=560&height=960&seq=app-mockup-phone&orientation=portrait"
                  alt="星球漫画移动端阅读界面"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}